export default {
  title: 'Êtes-vous sûr ?',
  description: 'Les groupes de modificateurs suivants (ainsi que leurs modificateurs) seront supprimés :',
  buttons: {
    yes: 'Oui',
    no: 'Non',
  },
  toasts: {
    modifier_group_got_deleted: 'Groupes de modificateurs supprimés',
    failed_to_delete_modifier_group: 'Échec de la suppression du groupe de modificateurs',
  },
};
